import { render, staticRenderFns } from "./MemberOrderGoods.vue?vue&type=template&id=0434c0b5&scoped=true"
import script from "./MemberOrderGoods.vue?vue&type=script&lang=js"
export * from "./MemberOrderGoods.vue?vue&type=script&lang=js"
import style0 from "./MemberOrderGoods.vue?vue&type=style&index=0&id=0434c0b5&prod&lang=scss&scoped=true"
import style1 from "./MemberOrderGoods.vue?vue&type=style&index=1&id=0434c0b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0434c0b5",
  null
  
)

export default component.exports